import { render, staticRenderFns } from "./FeatureUpdateTooltipContent.vue?vue&type=template&id=4f934466&scoped=true&"
import script from "./FeatureUpdateTooltipContent.vue?vue&type=script&lang=js&"
export * from "./FeatureUpdateTooltipContent.vue?vue&type=script&lang=js&"
import style0 from "./FeatureUpdateTooltipContent.vue?vue&type=style&index=0&id=4f934466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f934466",
  null
  
)

export default component.exports